import { APICore } from "./apiCore";

const api = new APICore();

function getUsers(type: string) {
  const baseUrl = `/users`;
  return api.get(`${baseUrl}/${type}`, {});
}

function updateUserStatusApi(params: { id: string; value: boolean }) {
  const baseUrl = "/users";
  

  return api.updatePatch(`${baseUrl}`, params);
}

function updateDeviceCountApi(params: { userId: string; count: number }) {
  const baseUrl = "/users/devices";
  

  return api.updatePatch(`${baseUrl}`, params);
}

function updateDeviceCountGloballyApi(params: { value: any }) {
  const baseUrl = "/devices";
  return api.update(`${baseUrl}`, params);
}

export {
  getUsers,
  updateUserStatusApi,
  updateDeviceCountGloballyApi,
  updateDeviceCountApi,
};
